import { configureStore } from "@reduxjs/toolkit";
import CutomizerSlice from "../reduce-slice/CutomizerSlice";
import SpeechTranscriptionSlice from "../reduce-slice/SpeechTranscriptionSlice";
import LoginSlice from "../reduce-slice/LoginSlice";
import OcrSlice from "../reduce-slice/OcrSlice";
import SummarizationSlice from "../reduce-slice/SummarizationSlice";
import ChatbotSlice from "../reduce-slice/ChatbotSlice";
import NotificationSlice from "../reduce-slice/NotificationSlice";
import AuditSlice from "../reduce-slice/AuditSlice";
import { useDispatch } from "react-redux";
import ManageTemplateSlice from "../reduce-slice/ManageTemplateSlice";
import EmployeeSlice from "../reduce-slice/EmployeeSlice";
import KnowledgeBaseSlice from "../reduce-slice/KnowledgeBaseSlice";
import AgentSlice from "../reduce-slice/AgentSlice";

export const store = configureStore({
  reducer: {
    customizer: CutomizerSlice,
    speechTranscriptionReducer: SpeechTranscriptionSlice,
    loginslice: LoginSlice,
    ocrReducer: OcrSlice,
    summarizeReducer: SummarizationSlice,
    chatbotReducer: ChatbotSlice,
    notificationReducer: NotificationSlice,
    auditSlice: AuditSlice,
    manageTemplateReducer: ManageTemplateSlice,
    employeeReducer:EmployeeSlice,
    knowledgeBaseReducer:KnowledgeBaseSlice,
    agentSliceReducer: AgentSlice
  },
});
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
